import { type HgSupportedLanguage } from '@smg-real-estate/domus';
import { type GeoSearchResultItem } from '@smg-real-estate/geo-libs';
import { type SearchHighlights } from '@smg-real-estate/geo-libs/dist/types/geo-api-responses';

import { getDisplayValue } from '@/helpers/geo/geoLocationHelper';

// const generateHighlightHTML = (
//   name: string,
//   highlights: {
//     from: number;
//     to: number;
//   }[],
// ): string => {
//   const [{ from, to }] = highlights; // only get the first highlight to know the user input
//   if (to > from && to <= name.length) {
//     const highlightedText = name.substring(from, to);
//     return name.replace(new RegExp(highlightedText, 'gi'), (match) => `<b>${match}</b>`);
//   }
//   return name;
// };
//
// export const getHighlightedDisplayValue = (
//   geoSearchResultItem: GeoSearchResultItem,
//   language: HgSupportedLanguage,
// ): string => {
//   const parts: string[] = [];
//
//   for (const name of geoSearchResultItem.geoLocation.names[language]) {
//     const html =
//       name in geoSearchResultItem.highlights
//         ? generateHighlightHTML(name, geoSearchResultItem.highlights[name])
//         : name;
//     parts.push(html);
//   }
//
//   return getDisplayValue(parts);

export const getHighlightedDisplayValue = (
  geoSearchResultItem: GeoSearchResultItem,
  language: HgSupportedLanguage,
): string => {
  const highlightedParts: string[] = [];

  for (const name of geoSearchResultItem.geoLocation.names[language]) {
    const highlightedName = getHighlightedName(name, geoSearchResultItem.highlights);
    highlightedParts.push(highlightedName);
  }

  return getDisplayValue(highlightedParts);
};

const getHighlightedName = (name: string, highlights: SearchHighlights): string => {
  if (!(name in highlights)) {
    return name;
  }

  let highlightedText = '';
  let currentIndex = 0;

  for (const { from, to } of highlights[name]) {
    if (!isInvalidRange(name, from, to)) {
      highlightedText += name.substring(currentIndex, from);
      highlightedText += `<b>${name.substring(from, to)}</b>`;
      currentIndex = to;
    }
  }

  highlightedText += name.substring(currentIndex);
  return highlightedText;
};

const isInvalidRange = (term: string, from: number, to: number): boolean =>
  from < 0 || from > term.length || to < 0 || to > term.length;
